module.exports = __webpack_public_path__ + "img/cert-iso-27001.3af82567.jpg";